// removed by extract-text-webpack-plugin
module.exports = {"timer":"timer__3I1aI"};


//////////////////
// WEBPACK FOOTER
// ./components/countdown/styles/CardCountdownTimer.scss
// module id = ZQjp
// module chunks = 1